import highlight from "highlight.js/lib/core";

import css from "highlight.js/lib/languages/css";
import javascript from "highlight.js/lib/languages/javascript";
import ts from "highlight.js/lib/languages/typescript";
import html from "highlight.js/lib/languages/xml";
import php from "highlight.js/lib/languages/php";
import bash from "highlight.js/lib/languages/bash";
import json from "highlight.js/lib/languages/json";
import ruby from "highlight.js/lib/languages/ruby";
import python from "highlight.js/lib/languages/python";

highlight.registerLanguage("css", css);
highlight.registerLanguage("javascript", javascript);
highlight.registerLanguage("ts", ts);
highlight.registerLanguage("html", html);
highlight.registerLanguage("php", php);
highlight.registerLanguage("bash", bash);
highlight.registerLanguage("json", json);
highlight.registerLanguage("ruby", ruby);
highlight.registerLanguage("python", python);

highlight.configure({
  ignoreUnescapedHTML: true,
});

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      highlight,
    },
  };
});